var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table-block"},[_vm._m(0),_c('tbody',_vm._l((_vm.options),function(item,i){return _c('tr',{key:i,staticClass:"table-block-item"},[_c('td',[_vm._v(_vm._s(item.title))]),_c('td',[_c('p',[_vm._v(_vm._s(item.description))])])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"table-header"},[_c('td',[_vm._v(" Название параметра ")]),_c('td',[_vm._v(" Значение параметра ")])])
}]

export { render, staticRenderFns }